<template>
  <div id="stickyBar" class="sticky-bar-wrapper">
    <transition name="sticky-transition">
      <div v-show="enableSticky" class="sticky-bar">
        <div class="sticky-bar-item-image">
          <div class="sticky-bar-image">
            <img v-if="desktopImageUrl" :src="desktopImageUrl" alt="Product Image" />
          </div>
        </div>
        <div class="sticky-bar-item-content">
          <div class="sticky-bar-text">
            <p v-if="brandname" class="sticky-bar-brand">{{ brandname }}</p>
            <p v-if="productname" class="sticky-bar-title">{{ formattedTitle }}</p>
            <p v-if="productdescription" class="sticky-bar-description">
              {{ formattedDescription }}
            </p>
          </div>
        </div>
        <div class="sticky-bar-cta"><slot /></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'sticky-bar',
  props: {
    pdpfirstimage: {
      type: Object,
      required: true,
    },
    brandname: {
      type: String,
      required: true,
      default: 'Kerastase',
    },
    productname: {
      type: String,
      required: true,
    },
    productdescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      enableSticky: false,
      cookieBannerHeight: 0,
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    formattedTitle() {
      return this.productname.length > 56
        ? this.productname.slice(0, 56) + '...'
        : this.productname;
    },
    formattedDescription() {
      return this.productdescription.length > 75
        ? this.productdescription.slice(0, 75) + '...'
        : this.productdescription;
    },
    desktopImageUrl() {
      // eslint-disable-next-line sonarjs/super-linear-regex -- preserve loose JSON key quoting
      const jsonStr = this.pdpfirstimage.replace(/'/g, '"').replace(/(\w+):/g, '"$1":');

      try {
        const parsedObject = JSON.parse(jsonStr);
        return parsedObject.desktop; // Access the desktop URL
      } catch {
        return '';
      }
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.adjustStickyWhenCookieBanner();
    }
    this.toggleMainContainerOverflow(true);

    /* istanbul ignore next */
    const handleCookieGone = () => {
      if (!this.isMobile) {
        this.cookieBannerHeight = 0;
        const stickyBar = document.getElementById('stickyBar');
        stickyBar.style.top = `${this.cookieBannerHeight}px`;
      }
    };
    window.eventBus.$on('cookie.gone', handleCookieGone);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.adjustStickyWhenCookieBanner);
  },
  beforeDestroy() {
    window.eventBus.$off('cookie.gone');
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.adjustStickyWhenCookieBanner);
    this.toggleMainContainerOverflow(false);
  },
  methods: {
    toggleMainContainerOverflow(enable) {
      const mainContainer = document.getElementById('main-container');
      if (mainContainer) {
        mainContainer.classList.toggle('no-horizontal-scroll', enable);
      }
    },

    handleScroll() {
      const element = document.getElementsByClassName('salon-locator-btn');
      const isInViewport = this.isInViewport(element ? element[0] : null);
      this.enableSticky = !isInViewport;
      if (this.enableSticky) {
        const stickyElement = document.querySelector('.sticky-bar');
        if (stickyElement) {
          stickyElement.style.display = 'flex';
        }
      }
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    adjustStickyWhenCookieBanner() {
      const cookieBanner = document.querySelector('.cookie-banner');
      const stickyBar = document.getElementById('stickyBar');
      if (cookieBanner) {
        this.cookieBannerHeight = cookieBanner.offsetHeight;
      }
      if (stickyBar && !this.isMobile) {
        stickyBar.style.top = `${this.cookieBannerHeight}px`;
      }
    },
  },
};
</script>
<style lang="scss" src="./sticky-bar.scss"></style>
